import { useTopNavigationLinks } from 'hooks/layout'
import { useHistory } from 'react-router-dom'

export function useTimesheetsTopNavigationLinks() {
  const history = useHistory()

  useTopNavigationLinks([
    {
      label: 'TIMESHEETS',
      urlMatcher: "/timesheets$",
      onClick: () => {
        history.push('/timesheets')
      },
    },
    {
      label: 'SAVED',
      urlMatcher: "/timesheets/saved",
      onClick: () => {
        history.push("/timesheets/saved")
      },
    }
  ])
} 